export const SESSION_COOKIE = 'btn_session';
export const LOGGED_IN_COOKIE = 'btn_logged_in';

export const TOAST_SUCCESS = 'success';
export const TOAST_ERROR = 'error';
export const TOAST_INFO = 'info';

export const QUERY_KEY_TOP_SHORTLINKS = 'top-shortlinks';
export const QUERY_KEY_AGG_CREATOR_STATS = 'agg-creator-stats';
export const QUERY_KEY_CREATOR_STATS = 'creator-stats';
export const QUERY_KEY_SHORTLINK_STATS = 'shortlink-stats';
export const QUERY_KEY_SHORTLINKS = 'shortlinks';
export const QUERY_KEY_SHORTLINK_BULK_UPLOADS = 'shortlink-bulk-uploads';
export const QUERY_KEY_CURATED_CLICKS_SUMMARY = 'curated-clicks-summary';
export const QUERY_KEY_CREATOR_CURATED_PAGES = 'creator-curated-pages';
export const QUERY_KEY_TOP_CURATED_SHORTLINKS = 'top-curated-shortlinks';
export const QUERY_KEY_CURATED_STATS_BY_CREATOR = 'curated-stats-by-creator';
export const QUERY_KEY_CURATED_STATS_BY_SHORTLINK =
  'curated-stats-by-shortlink';
export const QUERY_KEY_CURATED_STATS_BY_PAGE = 'curated-stats-by-page';
export const QUERY_KEY_USER_DATA = 'user-data';
export const QUERY_KEY_USER_PROFILE = 'user-profile';
export const MUTATION_KEY_USER_PROFILE = 'mutation-user-profile';
export const MUTATION_KEY_PROFILE_UPDATE_COUNTRY =
  'mutation-profile-update-country';
